import Page from './page';
// import Shop from './shop';
import Product from './product';
// import Customer from './customer';
import Order from './order';

export default {
  namespaced: true,

  modules: {
    page: Page,
    // shop: Shop,
    // customer: Customer,
    product: Product,
    order: Order,
  },
};
